import React from 'react';
import PropTypes from 'prop-types';
import { getTeamLogoUrl } from '~shared/utils/sportsbook';
import { useThemeMode } from '~SpectateStore/hooks/userHooks';

const TeamLogo = ({
    sportSlug,
    categorySlug,
    teamSlug,
    shouldShowAwayJersey,
    className,
}) => {
    const themeMode = useThemeMode();
    const teamLogoUrl = getTeamLogoUrl(sportSlug, categorySlug, teamSlug, shouldShowAwayJersey, themeMode);

    return (
        <img
            src={teamLogoUrl}
            className={className}
        />
    );
};

TeamLogo.propTypes = {
    sportSlug: PropTypes.string.isRequired,
    categorySlug: PropTypes.string.isRequired,
    teamSlug: PropTypes.string.isRequired,
    shouldShowAwayJersey: PropTypes.bool,
    className: PropTypes.string,
};

TeamLogo.defaultProps = {
    shouldShowAwayJersey: false,
    className: '',
};

export default TeamLogo;
